import React, { useState } from 'react';
import { FaTelegram, FaWhatsapp, FaEnvelope, FaComments } from 'react-icons/fa';
import './CTA.css';

const CTA = () => {
  const [emailCopied, setEmailCopied] = useState(false);

  const openChatwoot = () => {
    if (window.$chatwoot) window.$chatwoot.toggle('open');
  };

  const copyEmail = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigator.clipboard.writeText('contact@shadowexam.com');
    setEmailCopied(true);
    setTimeout(() => setEmailCopied(false), 2000);
  };

  return (
    <section className="cta-section">
      <div className="cta-container">
        <div className="cta-bg-glow cta-bg-glow--l" />
        <div className="cta-bg-glow cta-bg-glow--r" />

        <div className="cta-card">
          <div className="cta-ember" />
          <div className="cta-border" />

          <div className="cta-inner">
            <h2 className="cta-title">Ready for Your Next Challenge?</h2>
            <p className="cta-subtitle">
              Join 1000+ professionals who passed exams and aced interviews. Reach out — we're here 24/7.
            </p>

            <div className="contact-grid">

              <a href="https://t.me/shadowexam_bot" target="_blank" rel="noopener noreferrer" className="cc cc--tg">
                <div className="cc-icon-wrap">
                  <div className="cc-glow" />
                  <div className="cc-icon"><FaTelegram /></div>
                </div>
                <div className="cc-meta">
                  <span className="cc-title">Telegram</span>
                  <span className="cc-badge">Fastest</span>
                </div>
                <span className="cc-desc">Reply in minutes · Available 24/7</span>
                <span className="cc-cta">Open →</span>
              </a>

              <a href="https://wa.me/12365021836" target="_blank" rel="noopener noreferrer" className="cc cc--wa">
                <div className="cc-icon-wrap">
                  <div className="cc-glow" />
                  <div className="cc-icon"><FaWhatsapp /></div>
                </div>
                <div className="cc-meta">
                  <span className="cc-title">WhatsApp</span>
                  <span className="cc-badge">24/7</span>
                </div>
                <span className="cc-desc">Quick support · Always online</span>
                <span className="cc-cta">Open →</span>
              </a>

              <a href="mailto:contact@shadowexam.com" className="cc cc--mail">
                <div className="cc-icon-wrap">
                  <div className="cc-glow" />
                  <div className="cc-icon"><FaEnvelope /></div>
                </div>
                <div className="cc-meta">
                  <span className="cc-title">Email</span>
                  <span className="cc-badge">24h reply</span>
                </div>
                <span className="cc-desc cc-desc--email" onClick={copyEmail}>
                  {emailCopied ? '✓ Copied!' : 'contact@shadowexam.com'}
                </span>
                <span className="cc-cta">Send Email →</span>
              </a>

              <button onClick={openChatwoot} className="cc cc--chat">
                <div className="cc-icon-wrap">
                  <div className="cc-glow" />
                  <div className="cc-icon"><FaComments /></div>
                </div>
                <div className="cc-meta">
                  <span className="cc-title">Live Chat</span>
                  <span className="cc-badge">Instant</span>
                </div>
                <span className="cc-desc">Chat right now · On this page</span>
                <span className="cc-cta">Start Chat →</span>
              </button>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
